import safeUpdateFunction from "./safeUpdateFunction";

const editInput = (e, onChange, field, updateFunction, setCurrentValue) => {
    if(onChange){
        onChange(e, field);
    }

    const val = e.target.value;
    // console.log("val => ", val);
    

    safeUpdateFunction(e, val, updateFunction, field);
    setCurrentValue(val);
}

export default editInput;